import { createAction, props } from '@ngrx/store';
import { CommunicationRecord } from 'src/app/types/aggregate-graph.types';

export enum PatientCommsActionTypes {
	PresentCommunicationRecordModalRequested = '[Component] Present Communication Record Modal Requested',
	SaveCommunicationRecordRequested = '[Component] Save Communication Record Requested',
	SaveCommunicationRecordCompleted = '[Effect] Save Communication Record Completed',
	RemoveCommunicationRecordRequested = '[Component] Remove Communication Record Requested',
	RemoveCommunicationRecordCompleted = '[Effect] Remove Communication Record Completed',
	OwnerContactNoteChanged = '[Component] Owner Contact Note Changed'
}

export const presentCommunicationRecordModalRequested = createAction(
	PatientCommsActionTypes.PresentCommunicationRecordModalRequested,
	props<{ record: CommunicationRecord | null }>()
)

export const saveCommunicationRecordRequested = createAction(
	PatientCommsActionTypes.SaveCommunicationRecordRequested,
	props<{ record: CommunicationRecord }>()
)

export const saveCommunicationRecordCompleted = createAction(
	PatientCommsActionTypes.SaveCommunicationRecordCompleted,
	props<{ patientId: string, record: CommunicationRecord }>()
)

export const removeCommunicationRecordRequested = createAction(
	PatientCommsActionTypes.RemoveCommunicationRecordRequested,
	props<{ recordId: number }>()
)

export const removeCommunicationRecordCompleted = createAction(
	PatientCommsActionTypes.RemoveCommunicationRecordCompleted,
	props<{ patientId: string, recordId: number }>()
)

export const ownerContactNoteChanged = createAction(
	PatientCommsActionTypes.OwnerContactNoteChanged,
	props<{ clientId: string, contactNote: string }>()
)